// รหัสนำหน้าเลขโครงการ = ตัวอักษรล้วนที่ขึ้นต้น project_number (เช่น JS_26001 → JS, JSID_00001 → JSID)
// ใช้แทนการเช็ค /^JS_/ แบบ hardcode — รายการรหัสตั้งที่ /management/project-prefixes
export const leadingPrefix = (projectNumber) => {
  const m = /^[A-Za-z]+/.exec(String(projectNumber || '').trim());
  return m ? m[0].toUpperCase() : '';
};

// เลขโครงการนี้ขึ้นต้นด้วยรหัส (หรือหนึ่งในรายการรหัส) ที่ระบุหรือไม่
export const matchesProjectPrefix = (projectNumber, prefixOrList) => {
  const list = Array.isArray(prefixOrList) ? prefixOrList : [prefixOrList];
  const lead = leadingPrefix(projectNumber);
  return Boolean(lead) && list.some((p) => String(p || '').toUpperCase() === lead);
};

// รหัสที่ตัวกรอง "ประเภท" เลือกไว้เป็นค่าเริ่มต้น — เดิมคือ JS ถ้ายังอยู่ในรายการ ไม่งั้นใช้รหัสแรก
export const pickDefaultTypePrefixes = (prefixes) => {
  const list = Array.isArray(prefixes) && prefixes.length ? prefixes : ['JS'];
  return [list.includes('JS') ? 'JS' : list[0]];
};
